<template>
  <div id="app">
    <HeaderTop></HeaderTop>
    <router-view :key="$route.fullPath"/>
    <Foote></Foote>
  </div>
</template>

<script>
import './assets/css/com.css';
import HeaderTop from './components/HeaderTop';
import Foote from './components/Foote';
export default {
  name: 'App',
  components:{
    HeaderTop,
    Foote
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue